import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import ConstantHelper from "../Helpers/ConstantHelper";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { getSiteEmail } from "../Helpers/SiteConfig";
import usePageMeta from "../Helpers/usePageMeta";

const RefundPolicy = () => {
  usePageMeta({
    title: "Refund Policy | TZ Creation",
    description:
      "TZ Creation's refund policy for web design, development and IT service packages.",
    path: "/refund-policy",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <Breadcrumb
        parentpageName="Home"
        currentPageName="Refund Policy"
      />
      <section className="text-dark tnc_section section-gap pt-0">
        <div className="container py-3">
          <div className="row">
            <div className="col-12">
              <h2 className="mt-5 mb-2">REFUND POLICY</h2>
              <p>
                Thank you for choosing our IT Service Providing Company. We are
                committed to delivering high-quality services to our customers.
                However, we understand that there may be situations where a
                refund is necessary. This Refund Policy outlines the terms and
                conditions for requesting and receiving a refund from our
                company. Please carefully review this policy before submitting a
                refund request.
              </p>
              <h3 className="mt-5 mb-2">Eligibility for Refund:</h3>
              <ol>
                <li>
                  Refunds are applicable to services billed on a recurring
                  basis, such as monthly or annual subscriptions.
                </li>
                <li>
                  One-time service fees, advance payment, hardware purchases,
                  and third-party expenses are non-refundable.
                </li>
                <li>
                  Refunds are available within a specified period from the date
                  of the initial purchase or subscription renewal. The refund
                  period may vary depending on the specific service you have
                  subscribed to.
                </li>
                <li>
                  Refunds are only applicable to customers who have made
                  payments directly to our company. If you have made a payment
                  through a third-party provider, you will need to contact them
                  for refund requests.
                </li>
              </ol>
              <h3 className="mt-5 mb-2">Valid Refund Requests:</h3>
              <ol>
                <li>
                  <span className="font-w600">Service Disruption:</span> If you
                  experience a significant and prolonged service disruption that
                  prevents you from accessing or utilizing the subscribed
                  service, you may be eligible for a refund. You must promptly
                  notify our customer support team and allow us a reasonable
                  amount of time to address and resolve the issue before a
                  refund can be considered.
                </li>
                <li>
                  <span className="font-w600">
                    Dissatisfaction with Service:
                  </span>{" "}
                  If you are dissatisfied with the quality or performance of our
                  service, you may request a refund within the specified refund
                  period. We may ask for specific details regarding the reasons
                  for your dissatisfaction to help us improve our services.
                </li>
                <li>
                  <span className="font-w600">Double Billing:</span> In the
                  event of accidental double billing or overcharging, we will
                  issue a refund for the excess amount upon verification of the
                  error.
                </li>
              </ol>

              <h3 className="mt-5 mb-2">Limitations:</h3>
              <p className="mb-1 font-w600">
                Refunds will not be granted in the following situations:
              </p>
              <ul>
                <li>
                  Termination of services due to a violation of our terms of
                  service or acceptable usage policy.
                </li>
                <li>Changes in your business requirements or circumstances.</li>
                <li>
                  Failure to provide accurate information or cooperate in
                  resolving service-related issues.
                </li>
                <li>
                  Force majeure events or circumstances beyond our reasonable
                  control that may temporarily impact service availability.
                </li>
              </ul>
              <h3 className="mt-5 mb-2">Modifications to the Refund Policy:</h3>
              <p>
                Our company reserves the right to modify or update this Refund
                Policy at any time without prior notice. Any changes will be
                effective immediately upon posting the revised policy on our
                website.
              </p>
              <p>
                Please note that this Refund Policy is in addition to our Terms
                of Service and Privacy Policy. If you have any questions or
                concerns regarding our refund policy, please contact our
                customer support team for further assistance.
              </p>
              <h2 className="mt-5 mb-2">GENERAL TERMS FOR REFUND</h2>
              <p>
                TZ Creation offers a 100% Refund on all its design services,
                however it is not an unconditional 100% refund and certain
                conditions still apply.
              </p>
              <p className="mb-1 font-w600">
                TZ Creation Refund Policy will be Void if;
              </p>
              <ul>
                <li>You have chosen a special or a custom package.</li>
                <li>
                  The primary design concept (for any service) has been
                  approved.
                </li>
                <li>
                  You have demanded revisions beyond the initial design concepts
                  (for any service).
                </li>
                <li> The designs (for any service) have been finalized.</li>
                <li>
                  The website has been designed, developed and deployed live.
                </li>
                <li>
                  The company has not been contacted for more than 2 weeks
                  without notice.
                </li>
                <li>
                  If the project placed on hold upon customer request, the
                  refund will be voided.
                </li>
                <li> Company’s policies, or policy, have been violated.</li>
                <li>
                  Other company, agency, professional or agent has been
                  approached for the same project.
                </li>
                <li>
                  The creative brief is lacking in required information from the
                  client end.
                </li>
                <li>
                  A complete design change has been demanded and provided.
                </li>
                <li>
                  If a client subscribes for a service bundle and happens to be
                  dissatisfied with a particular service, refund will only be
                  applicable on that particular service and ‘not’ the entire
                  bundle.
                </li>
                <li>The business is closing or changing name or business.</li>
                <li>
                  Reasons such as ‘change of mind’, ‘disagreement with partner’
                  or other reasons that do not pertain to the service provided
                  will not be subject to refund under any circumstances.
                </li>
                <li>
                  Once a client has accepted multiple sets of revisions (for any
                  service), refund will not be applicable.
                </li>
                <li>
                  Services purchased exceeding 7 days and without a written
                  request expressing the client's intention to discontinue or
                  request a refund are not eligible for refunds under any
                  circumstances. These services are explicitly excluded from our
                  100% money-back guarantee.
                </li>
              </ul>

              <p className="mt-5 mb-1 font-w600">Charges:</p>
              <ul>
                <li>
                  In case where client express dissatisfaction with services not
                  covered under our 100% refund policy, TZ Creation management
                  will conduct a comprehensive review of the project. At our
                  discretion, we may offer a partial refund to the client after
                  deducting the charges for resources utilized during the
                  project and any other additional fees or expenses incurred.
                </li>
                <li>
                  Please be advised that 35% administration charges will be
                  applicable in case there's a change of mind on all orders
                  cancelled within 24 hours.
                </li>
                <li>
                  Cancellations of orders prior to project initiation due to
                  reasons unrelated to the design service itself for any number
                  of reasons will be subjected to a 35% cancellation
                  administrative fee.
                </li>
                <li>
                  To cancel a project prior to project initiation due to reason
                  unrelated to the service itself the refund request must be
                  made within 24 hours of order placement in order to receive a
                  full refund. Failing to do so will cause in receiving a
                  service fee charge if a cancellation is requested after the
                  initial 24 hours.
                </li>
              </ul>

              <h2 className="mt-5 mb-2">CLAIM YOUR REFUND</h2>
              <p className="mb-1 font-w600">
                To claim your refund, please follow any of the following steps:
              </p>
              <ul>
                <li>
                  Reaching out us on Whatsapp at{" "}
                  <span
                    onClick={() =>
                      window.open(
                        ConstantHelper.RefundRequestWhatsppMessage,
                        "_blank"
                      )
                    }
                    style={{
                      cursor: "pointer",
                      color: "#0d6efd",
                    }}
                  >
                    +971 58 176 5760
                  </span>
                  &nbsp; and talk with your respective Project Manager to
                  initiate a refund.
                </li>
                <li>
                  Live Chat. Click below button to start chat now and talk with
                  a representative to initiate a refund.
                </li>
                <li>
                  Sending us an Email at{" "}
                  <a href={`mailto:${getSiteEmail()}`}>{getSiteEmail()}</a> to
                  raise a refund request.
                </li>
              </ul>

              <h3 className="mt-5 mb-2">Refund Process:</h3>
              <ol>
                <li>
                  To request a refund, you must contact our customer support
                  team through email at{" "}
                  <a href={`mailto:${getSiteEmail()}`}>{getSiteEmail()}</a>.
                  Please provide your purchase details, the reason for the
                  refund request, and any supporting documentation if required.
                </li>
                <li>
                  Our customer support team will review your refund request
                  within a reasonable timeframe and may request additional
                  information or clarification if needed.
                </li>
                <li>
                  Once the required analysis is completed we will initiate the
                  process according to our refund policy stated above.
                </li>
                <li>
                  If your refund request is approved, we will initiate the
                  refund process. The refund will be issued using the same
                  payment method used for the original purchase unless otherwise
                  specified.
                </li>
                <li>
                  Refunds may take up to 7-14 Days to be processed and reflected
                  in your account.
                </li>
                <li>
                  The refund approval will be at discretion of TZ Creation
                  Management.
                </li>
                <li>Management's decision on the matter will be final.</li>
              </ol>

              <br />

              <p className="font-w600">
                After you have received your refund, you will not have any
                rights to any material submitted by TZ Creation, unless mutually
                agreed with by the company and the customer through written
                agreement.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default RefundPolicy;
